import React, { useMemo } from "react";
import { Icon, Box, Text } from "@bookingcom/bui-react";
export function IconWithBackground(props) {
    const { svg, backgroundColor, color, mixin, attributes, size } = props;
    const boxStyle = useMemo(() => ({ ...attributes?.style, display: "inline-block", lineHeight: 0, fontSize: 0 }), [attributes]);
    const textStyle = useMemo(() => ({ lineHeight: 0, fontSize: 0, display: "inline-block" }), []);
    return (React.createElement(Box, { padding: 2, mixin: mixin, borderRadius: 100, backgroundColor: backgroundColor, attributes: { ...attributes, style: boxStyle } },
        React.createElement(Text, { color: color, attributes: { style: textStyle } },
            React.createElement(Icon, { svg: svg, color: color, size: size }))));
}
